/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DeleteCustomerBranchOffice$Params {

/**
 * customer id
 */
  customerId: number;

/**
 * branch office id
 */
  branchOfficeId: number;
}

export function deleteCustomerBranchOffice(http: HttpClient, rootUrl: string, params: DeleteCustomerBranchOffice$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, deleteCustomerBranchOffice.PATH, 'delete');
  if (params) {
    rb.path('customerId', params.customerId, {});
    rb.path('branchOfficeId', params.branchOfficeId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

deleteCustomerBranchOffice.PATH = '/customers/{customerId}/branch-offices/{branchOfficeId}';
